import * as React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function MuiClipDateRangePicker({
  label,
  value,
  onChange,
  format = "yyyy/MM/dd",
  slotProps,
  ...pickerProps
}) {
  const mergedSlotProps = React.useMemo(() => {
    const textFieldProps = slotProps?.textField || {};
    return {
      ...slotProps,
      textField: {
        placeholder: textFieldProps.placeholder || format.toUpperCase(),
        inputProps: {
          inputMode: "numeric",
          ...textFieldProps.inputProps,
        },
        ...textFieldProps,
      },
    };
  }, [slotProps, format]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        value={value}
        onChange={onChange}
        format={format}
        slotProps={mergedSlotProps}
        {...pickerProps}
      />
    </LocalizationProvider>
  );
}
